"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterAutocomplete = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const react_select_1 = require("react-select");
const async_1 = require("react-select/async");
class FilterAutocomplete extends React.Component {
    constructor() {
        super(...arguments);
        this.handleChange = (selectedOption) => {
            if (this.props.onChange) {
                this.props.onChange((selectedOption && selectedOption.value) ||
                    selectedOption);
            }
        };
        this.loadDropdownOptions = (input, callback) => {
            const { items } = this.props;
            if (items && items.length) {
                const transformedOptions = this.transformFilterOptions();
                callback(this.filterValues(transformedOptions, input));
            }
            else {
                callback([]);
            }
        };
        this.filterValues = (options, inputValue) => {
            return options.filter(option => {
                const optionLabel = option.label.toLowerCase();
                return optionLabel.indexOf(inputValue.toLowerCase()) !== -1;
            });
        };
        this.getSelectedOption = (selectedValue, options) => {
            return options.filter(option => option.value === selectedValue)[0];
        };
        this.transformFilterOptions = () => {
            return this.props.items.map(item => {
                return {
                    label: item.value,
                    value: item.key,
                };
            });
        };
        this.renderDropdownIndicator = (props) => {
            return ((0, jsx_runtime_1.jsx)(react_select_1.components.DropdownIndicator, Object.assign({}, props, { children: (0, jsx_runtime_1.jsx)("span", { className: "icon icon-chevron-down-small" }) })));
        };
        this.renderClearIndicator = (props) => {
            return ((0, jsx_runtime_1.jsx)(react_select_1.components.ClearIndicator, Object.assign({}, props, { children: (0, jsx_runtime_1.jsx)("span", { className: "icon icon-cancel" }) })));
        };
        this.renderInput = (props) => {
            const InputComponent = react_select_1.components.Input;
            return ((0, jsx_runtime_1.jsx)(InputComponent, Object.assign({}, props, { autoComplete: "new-password" })));
        };
    }
    render() {
        const { selectedOption, items } = this.props;
        const defaultOptions = items ? this.transformFilterOptions() : [];
        const selectedFilter = this.getSelectedOption(selectedOption, defaultOptions);
        return ((0, jsx_runtime_1.jsx)(async_1.default, { cacheOptions: false, className: "form-autocomplete", classNamePrefix: "select-filter-autocomplete", components: {
                DropdownIndicator: this.renderDropdownIndicator,
                IndicatorSeparator: () => null,
                Input: this.renderInput,
                LoadingIndicator: () => null,
                LoadingMessage: () => null,
                NoOptionsMessage: () => null,
                ClearIndicator: this.renderClearIndicator,
            }, defaultOptions: defaultOptions, isClearable: true, loadOptions: this.loadDropdownOptions, name: "form-field-name", onChange: this.handleChange, openMenuOnClick: true, placeholder: this.props.placeholder || null, value: selectedFilter || null }));
    }
}
exports.FilterAutocomplete = FilterAutocomplete;
